export interface CCProductInfo {
    productType: string;
    quantity: number;
    information: string;
}

export interface CCContactInfo {
    email: string;
    emailCc: string;
    companyName: string;
    address: string;
    address1: string;
    postCode: string;
    city: string;
    country: string;
    localContactName: string;
    countryDialCode: string;
    telephoneNumber: string;
    mobileNumber: string;
}

export interface CCPalletInfo {
    id: number;
    // Dropdown menu with the following options: 
    // Euro Pallet – 120*80 cm and value must be "EURO PALLET"
    // Half Pallet – 60*80 cm "EURO HALF PALLET"
    // Other – pls provide measurements "OTHER"
    //All values are required except information
    //values must be greater than 10, should be change
    palletType: string;
    //All are in Centimeters
    width: number;
    length: number;
    height: number;    
    weight: number;
    quantity: number;
    information: string;
}
export interface CustomerCollection {
    cgiRefNumber: string;
    koNumber: string;
    isDone: boolean;
    collectionDate: Date | null;
    collectionHourFrom: number;
    collectionHourTo: number;
    collectionFrom: string;
    collectionNote: string;

    //If you have password then user must click minimum one password option and provide some passwords as well
    havePassword: boolean;
    haveFilePassword: boolean;
    isBiosPassword: boolean;
    biosPassword: string;
    isHddPassword: boolean;
    hddPassword: string;
    isMasterPassword: boolean;
    masterPassword: string;
    isMdmComputracePassword: boolean;
    mdmComputracePassword: string;
    isAutopilotPassword: boolean;
    autopilotPassword: string;

    contactInfo: CCContactInfo;
    products: CCProductInfo[],

    productType: string;
    quantity: number;
    information: string;

    //#region options   
    t1aEstimate: boolean;
    //Multiple choice between SecurityCageBox vs CartonBox and Quanitity is not required
    securityCageBox: boolean;
    // securityCageBoxOption: string;
    // securityCageBoxQty: number;
    securityCageBoxOption1: boolean;
    securityCageBoxQty1: number;
    securityCageBoxOption2: boolean;
    securityCageBoxQty2: number;
    securityCageBoxOption3: boolean;
    securityCageBoxQty3: number;
    additionalPackingMaterial: boolean;
    additionalPackingMaterialText: string;

    singleBox: boolean;
    singleBoxQty: number;
    //Choose multiple From Other (prepacked pallets or similar) , SecureTransport or onSitePacking
    //if OtherPrepackedPalletsOrSimilar is selected then User must add minimum One line of Pallets 
    //OtherPrepackedPalletsOrSimilarFreetext property is optional
    otherPrepackedPalletsOrSimilar: boolean;
    otherPrepackedPalletsOrSimilarFreetext: string;
    pallets: CCPalletInfo[];
    //Following properties are required while adding pallets
    palletType: string;
    //All are in Centimeters
    palletWidth: number;
    palletHeight: number;
    palletLength: number;
    palletWeight: number;
    palletQuantity: number;
    palletInformation: string;

    onSitePacking: boolean;
    secureTransport: boolean;
    weeeConfirmation: boolean;
    //#endregion

    createdAt: Date;
    attachments: any[];

    //Field comes from Kobshoved
    isGoodReceived: string;
    isPreScanDone: boolean;

    //No of unread comments
    customerUnReadCommentCount: number;
    t1aUnReadCommentCount: number;

    // Customer make it true when Collection will ready to collect
    isReadyToCollect: boolean;
    error: any;
}

export interface CustomerCollectionEmail {
    //Customer Collection Id
    id: string;
    attachments: any[];
}


export interface FullCustomerCollection extends CustomerCollection {
    id: string;
    isUpdated: boolean;
}

export class FullCustomerCollection implements FullCustomerCollection {
    constructor(init?: CCProductInfoFormValues) {
        Object.assign(this, init);
    }
}

export class CCProductInfoFormValues {
    id: string = "";
    createdAt: Date = new Date();
    cgiRefNumber: string = '';
    koNumber: string = "";
    havePassword: boolean = true;
    haveFilePassword: boolean = false;
    isBiosPassword: boolean = false;
    biosPassword: string = "";
    isHddPassword: boolean = false;
    hddPassword: string = "";
    isMasterPassword: boolean = false;
    masterPassword: string = "";
    isMdmComputracePassword: boolean = false;
    mdmComputracePassword: string = "";
    isAutopilotPassword: boolean = false;
    autopilotPassword: string = "";
    
    contactInfo: CCContactInfo = {
        email: '',
        emailCc: '',
        companyName: '',
        address: '',
        address1: '',
        postCode: '',
        city: '',
        country: '',
        localContactName: '',
        countryDialCode: '',
        telephoneNumber: '',
        mobileNumber: '',
    };

    products: CCProductInfo[] = [];
    //Following properties are required while adding products
    productType: string = "";
    quantity: number = 1;
    information: string = "";

    //#region options   
    t1aEstimate: boolean = false;
    //Multiple choice between SecurityCageBox vs CartonBox and Quanitity is not required
    securityCageBox: boolean = false;
    // securityCageBoxOption: string = '';
    // securityCageBoxQty: number = 0;

    securityCageBoxOption1: boolean = false;
    securityCageBoxQty1: number = 0;
    securityCageBoxOption2: boolean = false;
    securityCageBoxQty2: number = 0;
    securityCageBoxOption3: boolean = false;
    securityCageBoxQty3: number = 0;
    additionalPackingMaterial: boolean = false;
    additionalPackingMaterialText: string = '';

    singleBox: boolean = false;
    singleBoxQty: number = 0;
    //Choose multiple From Other (prepacked pallets or similar) , SecureTransport or onSitePacking
    //if OtherPrepackedPalletsOrSimilar is selected then User must add minimum One line of Pallets 
    //OtherPrepackedPalletsOrSimilarFreetext property is optional
    otherPrepackedPalletsOrSimilar: boolean = false;
    otherPrepackedPalletsOrSimilarFreetext: string = '';
    pallets: CCPalletInfo[] = [];
    //Following properties are required while adding pallets
    palletType: string = '';
    //All are in Centimeters
    palletWidth: number = 0;
    palletHeight: number = 0;
    palletLength: number = 0;
    palletWeight: number = 0;
    palletQuantity: number = 0;
    palletInformation: string = '';

    onSitePacking: boolean = false;
    secureTransport: boolean = false;
    weeeConfirmation: boolean = false;
    attachments: any[]=[];
    error: any = null;
    //#endregion



    constructor(collectionInfo?: CCProductInfoFormValues) {
        if (collectionInfo) {
            this.id = collectionInfo.id;
            this.createdAt = collectionInfo.createdAt;
            this.cgiRefNumber = collectionInfo.cgiRefNumber;
            this.koNumber = collectionInfo.koNumber;
            this.havePassword = collectionInfo.havePassword;
            this.haveFilePassword = collectionInfo.haveFilePassword;
            this.isBiosPassword = collectionInfo.isBiosPassword;
            this.biosPassword = collectionInfo.biosPassword;
            this.isHddPassword = collectionInfo.isHddPassword;
            this.hddPassword = collectionInfo.hddPassword;
            this.isMasterPassword = collectionInfo.isMasterPassword;
            this.masterPassword = collectionInfo.masterPassword;
            this.isMdmComputracePassword = collectionInfo.isMdmComputracePassword;
            this.mdmComputracePassword = collectionInfo.mdmComputracePassword;
            this.isAutopilotPassword = collectionInfo.isAutopilotPassword;
            this.autopilotPassword = collectionInfo.autopilotPassword;

            this.products = collectionInfo.products;
            this.productType = collectionInfo.productType;
            this.information = collectionInfo.information;
            this.quantity = collectionInfo.quantity;
            this.t1aEstimate = collectionInfo.t1aEstimate;
            this.securityCageBox = collectionInfo.securityCageBox;
            this.securityCageBoxOption1 = collectionInfo.securityCageBoxOption1;
            this.securityCageBoxOption2 = collectionInfo.securityCageBoxOption2;
            this.securityCageBoxOption3 = collectionInfo.securityCageBoxOption3;
            this.securityCageBoxQty1 = collectionInfo.securityCageBoxQty1;
            this.securityCageBoxQty2 = collectionInfo.securityCageBoxQty2;
            this.securityCageBoxQty3 = collectionInfo.securityCageBoxQty3;
            this.additionalPackingMaterial = collectionInfo.additionalPackingMaterial;
            this.additionalPackingMaterialText = collectionInfo.additionalPackingMaterialText;
            this.singleBox = collectionInfo.singleBox;
            this.singleBoxQty = collectionInfo.singleBoxQty;
            this.otherPrepackedPalletsOrSimilar = collectionInfo.otherPrepackedPalletsOrSimilar;
            this.otherPrepackedPalletsOrSimilarFreetext = collectionInfo.otherPrepackedPalletsOrSimilarFreetext;
            this.pallets = collectionInfo.pallets;
            this.onSitePacking = collectionInfo.onSitePacking;
            this.secureTransport = collectionInfo.secureTransport;
            this.weeeConfirmation = false;
            this.error = null;

            if (collectionInfo.contactInfo) {
                this.contactInfo.email = collectionInfo.contactInfo.email;
                this.contactInfo.emailCc = collectionInfo.contactInfo.emailCc;
                this.contactInfo.companyName = collectionInfo.contactInfo.companyName;
                this.contactInfo.address = collectionInfo.contactInfo.address;
                this.contactInfo.address1 = collectionInfo.contactInfo.address1;
                this.contactInfo.postCode = collectionInfo.contactInfo.postCode;
                this.contactInfo.city = collectionInfo.contactInfo.city;
                this.contactInfo.country = collectionInfo.contactInfo.country;
                this.contactInfo.localContactName = collectionInfo.contactInfo.localContactName;
                this.contactInfo.countryDialCode = collectionInfo.contactInfo.countryDialCode;
                this.contactInfo.telephoneNumber = collectionInfo.contactInfo.telephoneNumber;
                this.contactInfo.mobileNumber = collectionInfo.contactInfo.mobileNumber;
            }
        }
    }
}

export interface CustomerCollectionStep1 {
    email: string;
    koNumber: string;
    cgiRefNumber: string;
    companyName: string;
    address: string;
    address1: string;
    postCode: string;
    city: string;
    country: string;
    localContactName: string;
    countryDialCode: string;
    telephoneNumber: string;
    mobileNumber: string;
}
export interface CustomerCollectionStep2 {
    laptop: number;
    desktop: number;
    server: number;
    monitorTft: number;
    dockStationPort: number;
    hdd: number;
    smartPhoneTablet: number;
    officePrinter: number;
    mfpPrinter: number;
    mice: number;
    keyboard: number;
    cable: number;
    network: number;
}

export interface CustomerCollectionStep5 {
    collectionDate: Date | null;
    collectionHourFrom: number;
    collectionHourTo: number;
    collectionFrom: string;
    collectionNote: string;
}

export interface CustomerCollectionStep6 {
    //#region options   
    // t1aEstimate: boolean;
    //Multiple choice between SecurityCageBox vs CartonBox and Quanitity is not required
    securityCageBox: boolean;
    singleBox: boolean;
    singleBoxQty: number;
    //Choose multiple From Other (prepacked pallets or similar) , SecureTransport or onSitePacking
    //if OtherPrepackedPalletsOrSimilar is selected then Quantity and free text are required like ("Pls add measurements and weight of the pallets")
    otherPrepackedPalletsOrSimilar: boolean;
    otherPrepackedPalletsOrSimilarFreetext: string;
    //#endregion
}

export interface ICCSearchForm {
    orderBy: boolean;
    koNumber: string;
    refNr: string;
    companyName: string;
    city: string;
    country: string;    
}